import { useEffect, useRef, useState } from "react";

const useValidator = props => {
  const inputRef = props.inputRef || useRef(null);
  const inputValidations = props.inputValidations;
  const [error, setError] = useState('');

  const applyValidations = () => {
    if (inputRef.current && inputValidations) {
      Object.keys(inputValidations).forEach(attr => {
        if (attr !== "customValidation") {
          inputRef.current.setAttribute(attr, inputValidations[attr]);
        }
      });
    }
  };

  useEffect(() => {
    applyValidations();
    if (inputRef.current.value || props.validateOnRender) validationHandler();
  }, []);

  const validationHandler = (_event) => {
    let error = "";
    // Custom Validation Cases
    if (inputValidations && inputValidations.customValidation) {
      const { isInvalid, errorMessage } = inputValidations.customValidation();
      if (isInvalid) {
        error = errorMessage;
      }
    }
    else if (!inputRef.current.checkValidity()) {
      error = inputRef.current.validationMessage;
    }
    setError(error);
    return error;
  };

  return {
    inputRef,
    error,
    validationHandler
  };
};

export default useValidator;